<script setup>
import {computed, onMounted, ref} from "vue";

const ySmartCaptchaEnabled      = computed(() => import.meta.env.VITE_YANDEX_CAPTCHA_ENABLED.toLowerCase() === 'true');
const ySmartCaptchaLoaded       = computed(() => !!window.smartCaptcha);
const ySmartCaptchaClientKey    = computed(() => import.meta.env.VITE_YANDEX_CAPTCHA_CLIENT_KEY);
const ySmartCaptchaContainer    = ref(null);

const props = defineProps({
    modelValue: {type: [null, String], required: false, default: null},

    invisible: {type: [null, Boolean], required: false, default: false},
    testMode: {type: [null, Boolean], required: false, default: false},
});

const emits = defineEmits([
    'update:modelValue',
    'challengeVisible',
    'challengeHidden',
    'networkError',
    'javascriptError',
    'success',
    'tokenExpired'
]);

const modelProxy = computed({
    get: () => props.modelValue,
    set: (value) => emits('update:modelValue', value)
});

const execute = () => {
    if(!ySmartCaptchaEnabled.value) return;
    if(!ySmartCaptchaClientKey.value) return;
    if(!ySmartCaptchaLoaded.value) return;

    return window.smartCaptcha.execute();
}

onMounted(() => {
    if(!ySmartCaptchaEnabled.value) return;
    if(!ySmartCaptchaClientKey.value) return;
    if(!ySmartCaptchaLoaded.value) return;

    const widgetID = window.smartCaptcha.render(ySmartCaptchaContainer.value, {
        sitekey: ySmartCaptchaClientKey.value,
        hl: 'ru',
        test: Boolean(props.testMode),
        invisible: Boolean(props.invisible),
        callback: (token) => { modelProxy.value = token; },
        hideShield: true,
    });

    window.smartCaptcha.subscribe(widgetID, 'challenge-visible',() => { emits('challengeVisible'); })
    window.smartCaptcha.subscribe(widgetID, 'challenge-hidden', () => { emits('challengeHidden'); })
    window.smartCaptcha.subscribe(widgetID, 'network-error',    () => { emits('networkError'); })
    window.smartCaptcha.subscribe(widgetID, 'javascript-error', (error) => { emits('javascriptError', error); })
    window.smartCaptcha.subscribe(widgetID, 'success',          (token) => { emits('success', token); })
    window.smartCaptcha.subscribe(widgetID, 'token-expired',    () => { emits('tokenExpired'); })
});

defineExpose({
    execute,
});
</script>

<template>
    <div v-if="!ySmartCaptchaEnabled || !ySmartCaptchaClientKey" class="hidden"/>

    <template v-else>
        <div v-if="!ySmartCaptchaLoaded" class="py-4 px-2 border rounded bg-red-200 text-center text-xs">
            Неполадки в сервисе анализа подозрительного трафика.<br/>
            Обратитесь в техническую поддержку.
        </div>

        <div v-else>
            <div
                class="yandex-smart-captcha-container"
                :style="[!invisible ? {height: '100px'} : null]"
                ref="ySmartCaptchaContainer"
            />
        </div>
    </template>
</template>

<style scoped>

</style>
